
<template>
  <div>
    <div style="z-index:999;background: rgba(0, 0, 0, 0.03)">
      <a-card style="box-sizing: border-box; border-radius: 0 !important">
        <div  class="wps" >
          <div class="biaoti" style="cursor: pointer" @click="homepay">
            <div class="boxw">
<!--              <div class="httplogo" style="margin-top: -14px; padding-right: 10px; margin-left: 10px;width:370px;height: 85px;"></div>-->
              <img :src="httplogo" style=" margin-top: -14px; padding-right: 10px; margin-left: 10px;width:240px;height: 62px;" />
            </div>
          </div>

          <div class="ClickMenu" >
            <b class="Menu_b" @click="Menu(1)" v-if="fullPath != '/register'">首页</b>
            <b class="Menu_b" @click="Menu(2)" v-if="fullPath != '/register'">证书订购</b>
<!--            <b class="Menu_b" @click="Menu(3)" v-if="fullPath != '/register'">制图服务</b>-->
            <b class="Menu_b" @click="Menu(4)" v-if="fullPath != '/register'">年费服务</b>
            <b class="Menu_b" @click="Menu(5)" v-if="fullPath != '/register'">订单列表</b>
          </div>

          <div class="dianhua">
<!--            <img class="dianhua_img" src="@/assets/images/icon_kfdh.png" >-->
<!--            <div class="dianhua_content" style="">-->
<!--              <span style="font-size: 24px;font-family: Source Han Sans CN;font-weight: bold;color: #E99829;">0531-87903818<i style="font-style: normal;font-weight: normal;font-size: 12px;color: #000;margin-left: 10px;">(工作日 9:00 ~ 18:00) </i></span>-->
<!--            </div>-->
          </div>

          <!--    <span style="font-size: 16px;color:#999;line-height: 90px;">（工作日：9:00-18:00）</span>-->
        </div>
      </a-card>
    </div>
<!--    <div style="height:80px"></div>-->
  </div>

</template>
<script >
import {conf_list} from "@/api/manage";
import logoimg from './img/logo.png'
import {removeToken} from "@/utils/auth";
export default {
  data() {
    return {
      httplogo:logoimg,
      logoimg:logoimg,
      titlekey:1,
      current: ["mail"],
      collapsed: false,
      configdata: {},
      openKeys: [],
      value1: new Date(2016, 9, 10, 18, 40),
      value2: new Date(2016, 9, 10, 18, 40),
    };
  },
  created() {
    this.fullPath = this.$router.currentRoute.fullPath
    // this.httplogo = '/assets/liantuo/logo.png'//"/imgs/" + window.location.hostname + "/logo.png"
    // var configdata =  JSON.parse(localStorage.getItem('configdata'))
    // this.configdata = configdata
    conf_list({}).then((response) => {
      var obj = response.data;
      obj = JSON.stringify(obj);
      localStorage.setItem('configdata', obj)
      this.configdata = response.data
    });
  },
  methods: {
    Menu(index){
      if(index == 1){
        window.location.replace("/index");
      }else if(index == 2){
        this.$router.push("/index")
      }else if(index == 3){
        this.$router.push("/seal/index")
      }else if(index == 4){
        this.$router.push("/cost/index")
      }else if(index == 5){
        this.$router.push("/orderlist")
      }

    },
    gohome(){
      window.location.replace("/");
    },
    gokefu(){
      window.open('http://service.xahuadao.com/chat/pc?token=dd58500b04dfaa2f68f2cb59da614644&noCanClose=1','_blank')
    },
    homepay() {
      window.location.replace("/");
    },
  },
};
</script>

<style scoped lang="css">

.home-container {
  height: 100%;
}
.navitem{font-size: 15px;color: #FFFFFF}
.navitem:hover{cursor: pointer}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}


#components-layout-demo-custom-trigger .trigger:hover {
  color: #093d77;
}

#components-layout-demo-custom-trigger .logo {
  padding: 0;
  height: 32px;
  /*background: rgba(255, 255, 255, 0.2);/*/
  background: #001529;
  margin: 16px;
}

body {
  background-color: #fff !important;
}

b {
  color: #333;
}


.wps {
  /*background: #f5f5f5;*/
  background: #f9f9f9;
  display: flex;
  justify-content: space-around;
  height: 85px;
  line-height: 85px;
  text-align: center;
  align-items: center;
  border-bottom: 1px solid #c9c9c9;
  box-shadow: 0 -1px 5px rgb(0 0 0 / 10%);
}

.boxw {
  display: block;
  overflow: hidden;
  font-size: 46px;
  color: #FFFFFF;
  font-weight: 500;
  font-family: Microsoft YaHei UI Light;
  border-radius: 15px;
}

.biaoti {
  color: #000;
  display: flex;
  flex-direction: row;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  font-family: "黑体";
  overflow: hidden;
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: "";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}


.position_contbot span {
  display: block;
  height: 35px;
  line-height: 20px;
  padding: 7px 25px;
  color: #fff;
  margin-top: 5px;
  border-radius: 5px;
  box-sizing: border-box;
  background: #4278ff;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.ClickMenu{
  display: flex;
  width: 700px;
  height: 85px;
  //background: red;
  .Menu_b{
    display: block;
    margin: 0 20px 0 50px;
    font-size: 18px;
    cursor: pointer;
    font-weight: normal;
  }
  .Menu_b:hover{
    color: #ff4d4f;
    font-weight: bold;
    //font-size: 20px;
  }

}


.dianhua{
  display: flex;
  justify-content:flex-end;
  text-align: center;
  width: 400px;
  color: #000;
  font-size:24px;
  //margin-right: -50px;
}
.dianhua_img{
  display: block;
  width: 50px;
  height: 50px;
  margin: auto 20px auto 0;
}

.dianhua_content{
  display: flex;
  flex-direction: column;
  line-height: 50rpx;
  //line-height: 25px;
  text-align: left;
}
</style>
